var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "registerConfirm",
        staticClass: "sign-up",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onRegisterConfirm.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("login.registerConfirmTitle"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.registerConfirmResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.registerConfirmResponse.message,
                        type: _vm.registerConfirmResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.registerConfirmResponse.message = ""
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "token",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("login.confirmTokenLabel"),
                                label: _vm.$t("login.confirmTokenLabel"),
                                error: invalid && validated,
                                readonly: _vm.tokenLocked,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.registerConfirm.token,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerConfirm, "token", $$v)
                                },
                                expression: "registerConfirm.token"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _vm.createUser
                  ? [
                      _c("ValidationProvider", {
                        staticClass: "input-wrapper",
                        attrs: {
                          name: "password",
                          rules: "required|complexpw",
                          vid: "password",
                          tag: "div",
                          customMessages: {
                            required: _vm.$t("forms.errors.fieldEmpty"),
                            complexpw: _vm.$t("forms.errors.password")
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                var invalid = ref.invalid
                                var validated = ref.validated
                                var dirty = ref.dirty
                                return [
                                  _c("FormInput", {
                                    attrs: {
                                      type: "password",
                                      autocomplete: "new-password",
                                      placeholder: _vm.$t(
                                        "forms.labels.newPassword"
                                      ),
                                      label: _vm.$t("forms.labels.newPassword"),
                                      error: invalid && validated,
                                      disabled: _vm.disabled,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.registerConfirm.password,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.registerConfirm,
                                          "password",
                                          $$v
                                        )
                                      },
                                      expression: "registerConfirm.password"
                                    }
                                  }),
                                  _vm._v(" "),
                                  invalid && validated
                                    ? _c("span", {
                                        staticClass: "input-error",
                                        domProps: {
                                          innerHTML: _vm._s(errors[0])
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        staticClass: "input-wrapper",
                        attrs: {
                          name: "confirm",
                          vid: "confirm",
                          rules: "required|confirmed:password",
                          tag: "div",
                          customMessages: {
                            required: _vm.$t("forms.errors.fieldEmpty"),
                            confirmed: _vm.$t("forms.errors.passwordMatch")
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                var invalid = ref.invalid
                                var validated = ref.validated
                                var dirty = ref.dirty
                                return [
                                  _c("FormInput", {
                                    attrs: {
                                      type: "password",
                                      autocomplete: "new-password",
                                      placeholder: _vm.$t(
                                        "forms.labels.newPasswordRepeat"
                                      ),
                                      label: _vm.$t(
                                        "forms.labels.newPasswordRepeat"
                                      ),
                                      error: invalid && validated,
                                      disabled: _vm.disabled,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.registerConfirm.confirm,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.registerConfirm,
                                          "confirm",
                                          $$v
                                        )
                                      },
                                      expression: "registerConfirm.confirm"
                                    }
                                  }),
                                  _vm._v(" "),
                                  invalid && validated
                                    ? _c("span", {
                                        staticClass: "input-error",
                                        domProps: {
                                          innerHTML: _vm._s(errors[0])
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("login.registerConfirmButton"),
                    disabled: _vm.disabled
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }